import { useWizardNavigation } from '../../contexts';

export const usePackageStepProgress = () => {
  const { currentFormStep, allFormSteps } = useWizardNavigation();
  const byReference = allFormSteps.indexOf(currentFormStep);
  const index =
    byReference >= 0
      ? byReference
      : Math.max(
          allFormSteps.findIndex((step) => step.step === currentFormStep.step),
          0
        );

  return { currentStep: index + 1, totalSteps: allFormSteps.length };
};
